module.exports = __webpack_public_path__ + "static/media/sc2.f119c0d7.jpg";